import ThisModule from "./ContactsAndMessagesTable";

export default ThisModule;
